import {StringBuilder} from "../../AppUtils.js";
import {MainServices} from "../../consts.js";

export const CategoryTextToOriginalCategories = {
    [MainServices.HAPPY_HOURS]: [MainServices.HAPPY_HOURS, MainServices.PLATTERS],
    [MainServices.PACKAGES]: [MainServices.PACKAGES],
    [MainServices.WORKSHOPS]: [MainServices.WORKSHOPS]
};

export const FILTER_VERSION = 2;

export const MINIMUM_CHAR_LENGTH = 3;

export const MINIMUM_SEARCH_TEXT_WARNING = new StringBuilder("תנו לנו לפחות")
    .append(MINIMUM_CHAR_LENGTH)
    .append("אותיות – ואז נתחיל לחפש לכם בול מה שצריך")
    .toString();
